import React from "react";
import { CheckCircle2, Phone, Clock, ShieldCheck } from "lucide-react";
import QuoteForm from "@/components/forms/QuoteForm";
import { COMPANY } from "@/data/site";

export default function QuoteRequest() {
  return (
    <div data-testid="quote-page">
      <section className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
          <span className="text-xs font-semibold tracking-[0.18em] uppercase text-[#0284C7]">
            Free Quote
          </span>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-black text-[#0F172A] tracking-tight leading-[1.05]">
            Request a free, no-obligation estimate.
          </h1>
          <p className="mt-5 max-w-2xl text-base lg:text-lg text-slate-600">
            Tell us about your project and we'll get back to you with a clear,
            honest quote. For emergencies, call{" "}
            <a
              href={`tel:${COMPANY.phoneTel}`}
              data-testid="quote-page-phone-link"
              className="text-[#0284C7] font-semibold underline underline-offset-4"
            >
              {COMPANY.phone}
            </a>
            .
          </p>
        </div>
      </section>

      <section className="bg-slate-50 py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-5 gap-10">
          {/* SIDEBAR */}
          <div className="lg:col-span-2 space-y-6">
            <div className="bg-[#0F172A] text-white p-8" data-testid="quote-side-card">
              <h2 className="font-display text-2xl font-bold">
                Prefer to talk?
              </h2>
              <p className="mt-2 text-slate-300 text-sm">
                Call us directly — we'll diagnose the issue and quote on the
                phone whenever possible.
              </p>
              <a
                href={`tel:${COMPANY.phoneTel}`}
                data-testid="quote-side-call-link"
                className="mt-5 inline-flex items-center gap-2 bg-[#0284C7] hover:bg-[#0369A1] text-white font-semibold px-6 py-4 transition-colors"
              >
                <Phone className="h-5 w-5" strokeWidth={1.75} />
                {COMPANY.phone}
              </a>
            </div>

            <ul className="space-y-3 bg-white border border-slate-200 p-6">
              {[
                { icon: CheckCircle2, text: "Free, no-obligation estimate" },
                { icon: ShieldCheck, text: "Licensed & insured local plumbers" },
                { icon: Clock, text: "Fast response — often same business day" },
              ].map((b, i) => (
                <li
                  key={i}
                  data-testid={`quote-benefit-${i}`}
                  className="flex items-start gap-3"
                >
                  <b.icon className="h-5 w-5 mt-0.5 text-[#0284C7] flex-shrink-0" strokeWidth={1.75} />
                  <span className="text-sm text-[#0F172A] font-medium">
                    {b.text}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* FORM */}
          <div className="lg:col-span-3">
            <h2 className="font-display text-2xl lg:text-3xl font-bold text-[#0F172A]">
              Project details
            </h2>
            <p className="text-slate-600 mt-2">
              The more you share, the faster we can quote.
            </p>
            <div className="mt-6">
              <QuoteForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
